import { useEffect } from 'react';

import { uiStore } from '@/stores/ui.store';

/** Mirrors the shell theme choice onto `<body>` for the CSS presets; call from an observer */
export const useShellThemeEffect = () => {
  const shellTheme = uiStore.shellTheme;
  const shellAccentButtons = uiStore.shellAccentButtons;

  useEffect(() => {
    if (shellTheme === 'default') delete document.body.dataset.shellTheme;
    else document.body.dataset.shellTheme = shellTheme;
    if (shellAccentButtons) document.body.dataset.shellAccent = '';
    else delete document.body.dataset.shellAccent;
  }, [shellTheme, shellAccentButtons]);
};
